import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Link } from "react-router-dom";
import { ICONS } from "@/lib/data";

export default function ServiceModal({ service, open, onOpenChange }) {
    if (!service) return null;
    const Icon = ICONS[service.icon] || ICONS.BookOpen;
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid={`service-modal-${service.slug}`} className="max-w-2xl bg-background border-brand-border">
                <DialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <span className="grid place-items-center w-11 h-11 rounded-xl bg-brand-creamLight text-brand-ink">
                            <Icon size={20} strokeWidth={1.6} />
                        </span>
                        <DialogTitle className="font-serif text-3xl text-brand-ink leading-tight">
                            {service.title}
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-brand-muted text-base leading-relaxed pt-2">
                        {service.summary}
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-4 py-2">
                    <p className="overline">What we offer</p>
                    <ul className="space-y-2.5">
                        {service.bullets.map(b => (
                            <li key={b} className="flex gap-3 text-brand-ink/90 text-sm">
                                <span className="mt-2 inline-block w-1.5 h-1.5 rounded-full bg-brand-amber shrink-0" />
                                {b}
                            </li>
                        ))}
                    </ul>
                    {service.idealFor && (
                        <div className="mt-4 p-4 rounded-xl bg-brand-creamLight border border-brand-border">
                            <p className="overline mb-1">Ideal for</p>
                            <p className="text-sm text-brand-ink">{service.idealFor}</p>
                        </div>
                    )}
                </div>
                <DialogFooter className="pt-2">
                    <Link to="/contact" className="btn-primary w-full sm:w-auto" data-testid={`service-modal-cta-${service.slug}`}>
                        Request a consultation
                    </Link>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
